// extracted by mini-css-extract-plugin
var _1 = "P2IuR";
export { _1 as "base" }
